import { compact } from 'lodash';
import { useMemo } from 'react';

import {
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
} from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../../translations';

import { TimeBasedRefundTableBean } from './TimeBasedRefundInteractiveTable.types';
import { ThresholdInHoursCell } from './cells/ThresholdInHoursCell';
import { RefundPercentageCell } from './cells/RefundPercentageCell';

const t = serviceSettingsTranslationKeys.advancePayments.form.timeBasedRefundInteractiveTable;

export const useTimeBasedRefundInteractiveTableColumns = (): InteractiveTableColumnConfiguration<TimeBasedRefundTableBean>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         ordinalNumber: '50px',
         thresholdInHours: '50%',
         refundPercentage: '50%',
         options: '24px',
      });

      return compact([
         {
            name: 'ordinalNumber',
            label: t.ordinalNumber,
            width: columnsWidth.ordinalNumber,
            renderer: ({ index }) => {
               return <InteractiveTable.OrdinalNumberCell index={index} testId={'ordinalNumber'} />;
            },
         },
         {
            name: 'thresholdInHours',
            label: t.thresholdInHours.label,
            width: columnsWidth.thresholdInHours,
            renderer: ({ bean, index }) => (
               <ThresholdInHoursCell
                  defaultValue={bean.thresholdInHours}
                  index={index}
                  name={'thresholdInHours'}
                  testId={'thresholdInHours'}
               />
            ),
         },
         {
            name: 'refundPercentage',
            label: t.refundPercentage.label,
            width: columnsWidth.refundPercentage,
            renderer: ({ bean, index }) => (
               <RefundPercentageCell
                  defaultValue={bean.refundPercentage}
                  index={index}
                  name={'refundPercentage'}
                  testId={'refundPercentage'}
               />
            ),
         },
         {
            name: 'options',
            width: columnsWidth.options,
            renderer: ({ index, rowsCount }) => {
               return <InteractiveTable.DeleteRowCell index={index} disabled={rowsCount <= 1} />;
            },
         },
      ]);
   }, []);
};
